module.exports = __webpack_public_path__ + "static/media/puff-zen.e5657e91.png";